import classes from "../styles/App.module.scss";
import { FC } from "react";

type Props = {
    outputText: string[] | null;
    onClickDeleteButton: (index: number) => void;
}

export const OutputArea: FC<Props> = props => {
    const { outputText, onClickDeleteButton } = props;

    return (
        <section className={classes.outputArea}>
            <h2 className={classes.outputAreaTitle}>メモ一覧</h2>
            <ul className={classes.outputAreaList}>
            {
                outputText!.map((listItem: string, index: number) => 
                <li className={classes.outputAreaListItem} key={index}>
                    <span>{listItem}</span>
                    <button onClick={() => onClickDeleteButton(index)}>✕</button>
                </li>          
                )
            }
            </ul>
      </section>
    )
}